<template>
  <v-card class="pa-0 ma-0" height="500px" flat>
    <v-container style="overflow-y: hidden">
    <v-tabs height="35px" v-model="tab" active-class="fs-tab-active-class">
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1">
        Dados
      </v-tab>
      <v-tab href="#tab-2">
        Pedido
      </v-tab>
      <v-tab href="#tab-3">
        Interações
      </v-tab>
      <v-tab href="#tab-4">
        Alertas
      </v-tab>
      <v-tab href="#tab-5" v-if="itemMostrarDetalhes.feedback_comportamento !== '01'">
        Respostas Email
      </v-tab>
      <v-tab href="#tab-6" v-if="itemMostrarDetalhes.emotion_feedback_cliente">
        Feedback Cliente
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <dados class="mt-3" v-if="tab === 'tab-1'" :itemMostrarDetalhes="itemMostrarDetalhes" :fecharDialog="fecharDialog"/>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <pedido class="mt-3" v-if="tab === 'tab-2'" :itemMostrarDetalhes="itemMostrarDetalhes" :fecharDialog="fecharDialog"/>
      </v-tab-item>
      <v-tab-item value="tab-3">
        <interacoes class="mt-3" v-if="tab === 'tab-3'" :itemMostrarDetalhes="itemMostrarDetalhes" :fecharDialog="fecharDialog"/>
      </v-tab-item>
      <v-tab-item value="tab-4">
        <alertas class="mt-3" v-if="tab === 'tab-4'" :itemMostrarDetalhes="itemMostrarDetalhes" :fecharDialog="fecharDialog"/>
      </v-tab-item>
      <v-tab-item value="tab-5">
        <respostasemail class="mt-3" v-if="tab === 'tab-5'" :itemMostrarDetalhes="itemMostrarDetalhes" :fecharDialog="fecharDialog"/>
      </v-tab-item>
      <v-tab-item value="tab-6">
        <feebackcliente class="mt-3" v-if="tab === 'tab-6'" :itemMostrarDetalhes="itemMostrarDetalhes" :fecharDialog="fecharDialog"/>
      </v-tab-item>
    </v-tabs-items>
    <div v-if="itemMostrarDetalhes" class="fs-div-numeropedido">
      Nº PEDIDO: <b>{{ itemMostrarDetalhes.id.padStart(7, '0') }}</b> |
      <span v-if="itemMostrarDetalhes.valor_total">
        <b>{{ formatarMoeda(itemMostrarDetalhes.valor_total, 2) }}</b>
      </span>
      <br/>
      <strong>{{ retornarNome(itemMostrarDetalhes.nome, 30) }}</strong>
      <span v-if="!itemMostrarDetalhes.valor_total">
        <b> - SEM ITENS</b>
      </span>
    </div>
    </v-container>
  </v-card>
</template>

<script>
import Funcoes from '@/utils/Functions'
export default {
  props: {
    itemMostrarDetalhes: Object,
    fecharDetalhes: Function,
    tabInicial: String
  },
  components: {
    dados: () => import('@/views/app/crm/listagemdepedidos/tablepedidos/dialogcomponents/dados'),
    pedido: () => import('@/views/app/crm/listagemdepedidos/tablepedidos/dialogcomponents/pedido'),
    interacoes: () => import('@/views/app/crm/listagemdepedidos/tablepedidos/dialogcomponents/interacoes'),
    alertas: () => import('@/views/app/crm/listagemdepedidos/tablepedidos/dialogcomponents/alertas'),
    respostasemail: () => import('@/views/app/crm/listagemdepedidos/tablepedidos/dialogcomponents/respostasemail'),
    feebackcliente: () => import('@/views/app/crm/listagemdepedidos/tablepedidos/dialogcomponents/feebackcliente')
  },
  data () {
    return {
      tab: null
    }
  },
  created () {
    // console.log('Criado o Dialog de Detalhes')
    this.tab = this.tabInicial
  },
  methods: {
    retornarNome (conteudo, tamanho) {
      return Funcoes.limitarConteudo(conteudo, tamanho)
    },
    formatarMoeda (number, digits) {
      number = parseFloat(number).toFixed(digits)
      number = number.toString()
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(number)) { number = number.replace(pattern, '$1,$2') }
      return 'R$ ' + number
    },
    fecharDialog () {
      this.tab = null
      this.fecharDetalhes()
    }
  }
}
</script>

<style scoped>
  .fs-tab-active-class {
    background-color: #FAFAFA !important;
  }
  .fs-div-numeropedido {
    opacity: 0.8;
    position: absolute !important;
    right: 20px;
    top: 17px;
    font-size: 13px;
  }
</style>
